import React, { useState } from 'react'
import PropTypes from 'prop-types'
import { Disclosure } from '@headlessui/react'
import { ChevronDown, CalendarIcon } from 'lucide-react'
import MultiSelectDayDateTime from '../../leevo_ui/KlassForm/MultiSelectDayDateTime/MultiSelectDayDateTime'

function ClassScheduleSection({ dates, onChange }) {
  return (
    <Disclosure defaultOpen>
      {({ open }) => (
        <div className="bg-white dark:bg-gray-800 border border-gray-200 dark:border-gray-700 rounded-lg">
          <Disclosure.Button className="flex items-center justify-between w-full px-4 py-3 text-left">
            <div className="flex items-center space-x-2">
              <CalendarIcon className="w-5 h-5 text-purple-600" />
              <h3 className="text-base font-semibold text-gray-900 dark:text-gray-100">Class Schedule</h3>
            </div>
            <ChevronDown
              className={`w-5 h-5 text-gray-500 dark:text-gray-400 transition-transform ${
                open ? 'transform rotate-180' : ''
              }`}
            />
          </Disclosure.Button>

          <Disclosure.Panel className="px-4 pb-4 border-t border-gray-200 dark:border-gray-700">
            <div className="mt-4">
              <p className="mb-3 text-sm text-gray-600 dark:text-gray-400">
                Select one or more days of the week for this class to run.
              </p>
              <MultiSelectDayDateTime value={dates} onChange={onChange} />
            </div>
          </Disclosure.Panel>
        </div>
      )}
    </Disclosure>
  )
}

ClassScheduleSection.propTypes = {
  dates: PropTypes.array.isRequired,
  onChange: PropTypes.func.isRequired
}

export default ClassScheduleSection
